module.exports = __webpack_public_path__ + "static/goblin-2a805077f7e51251c04c3cad218d592e.jpg";